var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center align-center flex-column"},[_c('m-chip-group',{staticClass:"mt-4",attrs:{"items":_vm.items,"i18n-path":"onboarding.use_for.items","validation-rules":"required"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }